var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('kst-output',{attrs:{"field":"SelfWarehouseID","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }